import React, { Component } from 'react';

class Donation extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <div>
                <h1>sadsadasdaas</h1>
            </div>
         );
    }
}
 
export default Donation;